export default "__VITE_ASSET__XCjVmCex__"